import React, {useEffect, useCallback} from 'react';
import {
	Loader,
	Slider,
	Tree,
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import upArrowIcon from '../../../assets/upArrow.svg';
import Styles from './index.module.scss';
import _ from 'lodash';
import {payloadKeyValueMap } from './constants';
export type MapStatePropsType = {
	params: any;
	payloadData:any,
	page: number,
	total: number,
	inProgress: boolean,
	appliedFilters: Record<string, any>,
	globalTotal: number,
	paginationInProgress: boolean
};

export type DispatchPropsType = {
	onClose: () => void;
	loadPayloadData : (
		filters?: Record<string, any>,
		property?: string
	) => void,
};
// const getParsedValue =(type:string,val:string)=>{
// 	if(type === "days" || type === 'day') return daysMap[val] || val;
// 	// if(type === "language") return languageMap[val] || val;
// 	// else if(type === "speech_rate") return speedMap[val] || val;
// 	else return val;
// };

const PayloadModal: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onClose,
	params,
	loadPayloadData,
	payloadData,
	inProgress,
}) => {
	const { t } = useTranslation();

	useEffect(()=>{
		const {_id} = params;
		loadPayloadData({_id,payload:1},'widget_data');
	},[]);

	const getTitle = (): string => {
		return t('KLR00432');
	};

	const getNodes = (object:any,firstLevel=false,isChildOfReplacedVariable=false,parentKey:string="",level:number=0):any => {
		return Object
			.entries(object)
			.map(([key, value]) => {
				let isChild = isChildOfReplacedVariable;
				if(firstLevel && key === "replacement") isChild = true;
				return value && typeof value === 'object'
						? { title: key, key: `${parentKey}-${level}-${key}`, children: getNodes(value,false,isChild,key,level+1),firstLevel, isChildOfReplacedVariable: !firstLevel && isChild}
						: { title: key, key: `${parentKey}-${level}-${key}`, value,firstLevel,isChildOfReplacedVariable:!firstLevel && isChild }
				}
			);
	}
	const getRequiredData = useCallback((data) => {
		if(_.isEmpty(data)) return {};
		let obj:Record<string, any> = {};
		const firstObj = data[0];
		const {status,reason,configuration} = firstObj;
		if(firstObj._id) delete firstObj._id;
		if(status) {
			obj.status = status;
			delete firstObj.status;
		}
		if(reason) {
			obj.reason = reason;
			delete firstObj.reason;
		}
		if(configuration) {
			obj.configuration = JSON.parse(configuration);
			delete firstObj.configuration;
		}
		Object.entries(firstObj).forEach(([key, value]) => {
			if(!_.isEmpty(value)) obj[key] = value;
		})
		return obj;
	},[]);

	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			title={getTitle()}
		>
			<div className="mt-4">
				{inProgress && <Loader/>}
				{!inProgress && <Tree
					treeData={getNodes({...getRequiredData(payloadData)},true)}
					switcherIcon={<img alt="down arrow icon" className={Styles.switcherIcon} src={upArrowIcon}/>}
					titleRender={ (a:any) => {
						const transformedKey = !a.isChildOfReplacedVariable && payloadKeyValueMap[a.title];
						if(a.hasOwnProperty('value')){
							let showValueNode = (a.value || a.value === 0 || a.value === false);
							return (
								<div
									className={[Styles.row, a.firstLevel ? Styles.boldHeading : ""].join(' ')}
									key={a.key}
								>
									<div className={[Styles.leftCol,Styles.treeKeyNode].join(" ")}>
										{transformedKey ? t(transformedKey) : a.title} :
									</div>
									{ showValueNode ? <div className={[Styles.rightCol,Styles.treeValueNode].join(" ")}>
										{`${a.value}`}
										{/*{`${getParsedValue(a.title,a.value)}`}*/}
									</div> : ""}
								</div>)
						}else return (<div key={a.key} className={[a.firstLevel ? Styles.boldHeading : Styles.treeKeyNode].join(' ')}>{transformedKey ? t(transformedKey) : a.title}</div>);
					}}
				/>}
			</div>
		</Slider>
	);
};

export default PayloadModal;
